import React from "react";
import styled, { keyframes } from "styled-components";

import ai from "../img/AODG26844.png";



const pulse = keyframes`

0%,100%{
opacity:.4;
transform:scale(1);
}

50%{
opacity:.8;
transform:scale(1.2);
}

`;



const float = keyframes`

0%,100%{
transform:translateY(0);
}

50%{
transform:translateY(-18px);
}

`;




const Section = styled.section`

width:100%;

min-height:550px;


position:relative;


  background: radial-gradient(circle at top, #081a2f, #081a2f);


display:flex;

align-items:center;


overflow:hidden;


`;





const Overlay = styled.div`

position:absolute;

inset:0;


background:

linear-gradient(

120deg,

rgba(2,6,23,.96),

rgba(8,26,47,.85)

);


`;





const Glow = styled.div`

position:absolute;


width:350px;

height:350px;


background:#38bdf8;


filter:blur(130px);


right:10%;


animation:${pulse} 5s infinite;


`;






const Wrapper = styled.div`

position:relative;

z-index:2;


width:100%;


max-width:1400px;


margin:auto;


padding:80px 25px;


display:flex;


align-items:center;


gap:70px;


direction:ltr;



@media(max-width:850px){

flex-direction:column-reverse;

}

`;





const TextBox = styled.div`

flex:1;

direction:rtl;

padding:45px;

border-radius:40px;

background:
rgba(255,255,255,.08);

backdrop-filter:blur(25px);

border:
1px solid rgba(255,255,255,.25);

box-shadow:
0 30px 80px rgba(0,0,0,.6);

position:relative;

display:flex;
flex-direction:column;
justify-content:center;
align-items:center;

text-align:center;



&:before{

content:"";

position:absolute;

inset:0;

border-radius:40px;

padding:1px;

background:
linear-gradient(
135deg,
#38bdf8,
transparent,
#38bdf8
);

-webkit-mask:
linear-gradient(#fff 0 0) content-box,
linear-gradient(#fff 0 0);

-webkit-mask-composite:xor;

}

`;



const Title = styled.h2`

font-size:

clamp(2.5rem,5vw,4rem);


font-weight:1000;


color:white;


text-align:center;


margin-bottom:30px;



span{

color:#38bdf8;


text-shadow:

0 0 25px #38bdf8;


}



`;






const Text = styled.p`

color:#e2e8f0;


font-size:18px;


line-height:2;


margin:18px 0;


font-weight:500;


`;







const ImageBox = styled.div`

flex:1;


display:flex;


justify-content:center;


align-items:center;



img{


width:clamp(240px,35vw,450px);


animation:${float} 5s ease-in-out infinite;



filter:

drop-shadow(

0 0 45px rgba(56,189,248,.9)

);


}



`;







export function About(){


return(

<Section>


<Overlay/>


<Glow/>



<Wrapper>



<TextBox>


<Title>

אודות <span>החברה</span>

</Title>



<Text>

שי גדפור | אומנות הניקיון והתחזוקה
</Text>



<Text>

חברת הניקיון המובילה בהנהלת שי גדפור מביאה לשטח הרבה שנות מוניטין, ניסיון עשיר וצוות מיומן, המספקים פתרונות ניקיון מתקדמים בסטנדרט בלתי מתפשר. אנו מתמחים בהפיכת כל חלל — פרטי, עסקי או ציבורי — לסביבה נקייה, מבריקה ומזמינה.

</Text>



<Text>

המומחיות שלנו בשטח:
</Text>



<Text>

פרויקטים לאחר שיפוץ: הסרה מוחלטת של אבק בנייה, שאריות צבע, דבקים ורובה, אחזקת משרדים ושטחי מסחר: יצירת סביבת עבודה פרודוקטיבית, ייצוגית והגיינית, בנייני ציבור ומוסדות: ניהול מערכי ניקיון מורכבים בחללים רחבי ידיים
</Text>



<Text>

החתימה המקצועית שלנו:
</Text>




<Text>

טכנולוגיית קצה: שימוש במכשור תעשייתי מתקדם וחומרי ניקיון מובילים, ניהול קפדני: עמידה אבסולוטית בלוחות זמנים, שקיפות מלאה וליווי אישי מול שי גדפור, אחריות מוחלטת: מחירים הוגנים והתחייבות מלאה לתוצאה מושלמת בכל פרויקט
</Text>




<Text>
למה לקוחות בוחרים בשי גדפור שוב ושוב?
</Text>

<Text>
✨ ניסיון וותק: מקצועיות שנמדדת בתוצאות בשטח.✨ שקיפות ואמינות: ליווי אישי של שי מתחילת העבודה ועד למסירת המפתח.✨ אחריות וזמנים: עומדים במילה שלנו, עומדים בלו"ז ובמחירים הכי הוגנים שיש.אל תתפשרו על פחות מהטוב ביותר. צרו קשר עוד היום וקבלו הצעת מחיר

</Text>



</TextBox>





<ImageBox>


<img src={ai} alt="S.G One"/>


</ImageBox>




</Wrapper>



</Section>


);


}